<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户姓名" prop="username">
                        <Input disabled v-model="info.username" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label="性别" prop="gender">
                        <Select disabled v-model="info.gender" transfer clearable placeholder>
                            <Option
                                    v-for="(item, index) in genderList"
                                    :value="item.id"
                                    :key="index"
                            >{{item.text}}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机号1" prop="phone">
                        <Input disabled v-model="info.phone" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label="手机号2" prop="phoneTwo">
                        <Input disabled v-model="info.phoneTwo" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label="手机号3" prop="phoneThree">
                        <Input disabled v-model="info.phoneThree" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label="手机号4" prop="phoneFour">
                        <Input disabled v-model="info.phoneFour" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" v-if="showSimpleForm">
                <Col span="12">
                    <FormItem label="经纪人" prop="brokerName">
                        <Input disabled v-model="info.brokerName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="经纪人电话" prop="brokerPhone">
                        <Input disabled v-model="info.brokerPhone" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label="意向楼盘" prop="projName">
                        <Input disabled v-model="info.projName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12" v-if="!showSimpleForm">
                    <FormItem label prop="attachments">
                        <preview-upload multiple
                                        v-model="info.attachments"
                                        readonly
                                        data-format="json"
                        ></preview-upload>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="当前置业顾问" prop="currUserId">
                        <form-lookup v-model="info.currUserId"
                                     placeholder
                                     :disabled="actionStatus != '1'"
                                     title="选择当前置业顾问"
                                     textSymbol="nickname"
                                     :modalHeight="540"
                                     :modalWidth="800"
                                     :options.sync="currUser">
                            <select-consultant :projId="info.projId">
                            </select-consultant>
                        </form-lookup>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="指定置业顾问" prop="targetUserName">
                        <Input disabled v-model="info.targetUserName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="报备时间" prop="reportTime">
                        <DatePicker
                                disabled
                                v-model="reportTime"
                                transfer
                                style="width: 100%"
                                type="datetime"
                        ></DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="保护期(截止到)" prop="protection">
                        <DatePicker
                                disabled
                                v-model="protection"
                                transfer
                                style="width: 100%"
                                type="datetime"
                        ></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12" v-if="isVisit">
                    <FormItem label="到访时间" prop="visitTime">
                        <DatePicker
                                :disabled="visitReadonly"
                                v-model="visitTime"
                                transfer
                                style="width: 100%"
                                type="datetime"
                        ></DatePicker>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12" v-if="isDeal">
                    <FormItem label="成交时间" prop="dealTime">
                        <DatePicker
                                :disabled="dealReadonly"
                                v-model="dealTime"
                                transfer
                                style="width: 100%"
                                type="datetime"
                        ></DatePicker>
                    </FormItem>
                </Col>
                <Col span="12" v-if="isDeal">
                    <FormItem label="成交金额" prop="dealAmount">
                        <input-number :disabled="dealReadonly" v-model="info.dealAmount" placeholder>
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24" v-if="isDeal">
                    <FormItem label="成交说明" prop="dealRemark">
                        <Input
                                :disabled="dealReadonly"
                                v-model="info.dealRemark"
                                type="textarea"
                                :rows="3"
                                placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12" v-if="isLiquidation">
                    <FormItem label="结佣时间" prop="liquidationTime">
                        <DatePicker
                                :disabled="liquidationReadonly"
                                v-model="liquidationTime"
                                transfer
                                style="width: 100%"
                                type="datetime"
                        ></DatePicker>
                    </FormItem>
                </Col>
                <Col span="12" v-if="isLiquidation">
                    <FormItem label="结佣金额" prop="liquidationAmount">
                        <input-number
                                :disabled="liquidationReadonly"
                                v-model="info.liquidationAmount"
                                placeholder
                        >
                            <span slot="append">元</span>
                        </input-number>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24" v-if="isLiquidation">
                    <FormItem label="结佣说明" prop="liquidationRemark">
                        <Input
                                :disabled="liquidationReadonly"
                                v-model="info.liquidationRemark"
                                type="textarea"
                                :rows="3"
                                placeholder
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24" v-if="!showSimpleForm">
                    <FormItem label="客户备注" prop="remark">
                        <Input disabled v-model="info.remark" type="textarea" :rows="3" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20" v-if="!showSimpleForm">
                <Col span="12">
                    <FormItem label="经纪人" prop="brokerName">
                        <Input disabled v-model="info.brokerName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="经纪人电话" prop="brokerPhone">
                        <Input disabled v-model="info.brokerPhone" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
    import {customerReportView, customerReportUpdate, customerReportConfirm} from '@/api/customer-recommend'
    import {intentionUpdate} from '@/api/customer-intention'
    import {ymdL, toDate} from '_u/helper'
    import SelectConsultant from '_vc/select-consultant'
    import PreviewUpload from '_c/preview-upload'
    import Enum from '_u/enum'
    const sex = Enum.get('sex')

    export default {
        name: 'FormRecommend',

        props: {
            id: {
                type: [String, Number],
                default: ''
            },
            // 操作标识
            actionStatus: {
                type: [String, Number],
                default: ''
            },
            // 状态页面标识
            customerStatus: {
                type: [String, Number],
                default: ''
            },
            //执行状态
            execStatus: {
                type: [String, Number],
                default: ''
            }
        },

        components: {
            SelectConsultant,
            PreviewUpload
        },

        inject: {
            $modal: {
                default: null
            }
        },

        data() {
            return {
                loading: false,
                info: {
                    id: this.id,            // 报备编号
                    customerStatus: '',     // 报备状态
                    customerId: '',         // 客户编号
                    username: '',           // 客户姓名
                    gender: '',             // 性别
                    phone: '',              // 手机号1
                    phoneTwo: '',           // 手机号2
                    phoneThree: '',         // 手机号3
                    phoneFour: '',          // 手机号4
                    remark: '',             // 客户备注
                    reportTime: '',         // 报备时间
                    protection: '',         // 保护期(截止到)
                    visitTime: '',          // 到访时间
                    dealTime: '',           // 成交时间
                    dealAmount: '',         // 成交金额
                    dealRemark: '',         // 成交说明
                    liquidationTime: '',    // 结佣时间
                    liquidationAmount: '',  // 结佣金额
                    liquidationRemark: '',  // 结佣说明
                    projId: '',             // 项目编号
                    projName: '',           // 项目名称
                    intentionId: '',        // 意向楼盘编号
                    currUserId: '',         // 当前置业顾问
                    currUserName: '',       // 当前置业顾问名称
                    targetUserId: '',       // 指定置业顾问
                    targetUserName: '',     // 指定置业顾问名称
                    attachments: '',        // 楼盘图片
                    intentionVer: '',       // 意向楼盘版本
                    brokerId: '',           // 经纪人编号
                    brokerName: '',         // 经纪人
                    brokerPhone: '',        // 经纪人电话
                    ver: ''                 // 版本号
                },
                currUser: [],
                sex: Enum.get('sex'),
            }
        },

        computed: {
            isVisit() {
                return this.loading || this.actionStatus == '2' ||
                this.customerStatus == '2' || this.customerStatus == '3' || 
                this.customerStatus == '4'
            },
            visitReadonly() {
                return this.loading || this.actionStatus != '2'
            },
            isDeal() {
                return this.loading || this.actionStatus == '3' || 
                this.customerStatus == '3' || this.customerStatus == '4'
            },
            dealReadonly() {
                return this.loading || this.actionStatus != '3'
            },
            isLiquidation() {
                return this.loading || this.actionStatus == '4' ||
                this.customerStatus == '4'
            },
            liquidationReadonly() {
                return this.loading || this.actionStatus != '4'
            },
            showSimpleForm() {
                return this.loading || this.actionStatus == '2' ||
                this.actionStatus == '3' || this.actionStatus == '4'
            },
            ruleValidate() {
                return {
                    currUserId: [
                        {
                            required: this.actionStatus == '1',
                            message: '当前置业顾问必填'
                        }
                    ],
                    visitTime: [
                        {
                            required: this.actionStatus == '2',
                            message: '到访时间必填'
                        }
                    ],
                    dealTime: [
                        {
                            required: this.actionStatus == '3',
                            message: '成交时间必填'
                        }
                    ],
                    dealAmount: [
                        {
                            required: this.actionStatus == '3',
                            message: '成交金额必填'
                        }
                    ],
                    liquidationTime: [
                        {
                            required: this.actionStatus == '4',
                            message: '结佣时间必填'
                        }
                    ],
                    liquidationAmount: [
                        {
                            required: this.actionStatus == '4',
                            message: '结佣金额必填'
                        }
                    ]
                }
            },
            reportTime: {
                get() {
                    return this.info.reportTime
                        ? toDate(this.info.reportTime)
                        : ''
                },
                set(val) {
                    this.info.reportTime = ymdL(val)
                }
            },
            protection: {
                get() {
                    return this.info.protection
                        ? toDate(this.info.protection)
                        : ''
                },
                set(val) {
                    this.info.protection = ymdL(val)
                }
            },
            visitTime: {
                get() {
                    return this.info.visitTime ? toDate(this.info.visitTime) : ''
                },
                set(val) {
                    this.info.visitTime = ymdL(val)
                }
            },
            dealTime: {
                get() {
                    return this.info.dealTime ? toDate(this.info.dealTime) : ''
                },
                set(val) {
                    this.info.dealTime = ymdL(val)
                }
            },
            liquidationTime: {
                get() {
                    return this.info.liquidationTime ? toDate(this.info.liquidationTime) : ''
                },
                set(val) {
                    this.info.liquidationTime = ymdL(val)
                }
            },
            genderList() {
                return this.sex.toList()
            }
        },

        methods: {
            fetch() {
                if (this.id) {
                    return customerReportView(this.id)
                } else {
                    return Promise.resolve()
                }
            }
        },

        mounted() {
            var $info = this.$refs.info,
                btns = [{type: 'default', text: '关闭', name: 'cancel'}]
            // 按钮定制
            if (this.actionStatus == '1') {
                btns.unshift({type: 'primary', text: '确定报备', name: 'confirm'})
            } else if (this.actionStatus == '2') {
                btns.unshift({type: 'primary', text: '确定到访', name: 'confirm'})
            } else if (this.actionStatus == '3') {
                btns.unshift({type: 'primary', text: '确定成交', name: 'confirm'})
            } else if (this.actionStatus == '4') {
                btns.unshift({type: 'primary', text: '确定结佣', name: 'confirm'})
            }
            this.$modal.updateBtns(btns)
            // 预加载
            this.$modal.beforeEnter(next => {
                Promise.all([this.fetch()])
                    .then(args => {
                        var [view] = args
                        if (view) {
                            var viewData = view.data
                            Object.keys(this.info).forEach(
                                name => (this.info[name] = viewData[name])
                            )

                            this.currUser.push({
                                id: this.info.currUserId,
                                nickname: this.info.currUserName
                            })
                        }
                    })
                    .finally(() => {
                        next()
                    })
            })

            // 确定
            this.$modal.onBtnClick('confirm', (next, options) => {
                $info.validate()
                    .then(() => {
                        this.info.customerStatus = this.actionStatus
                        var formData = Object.assign({}, this.info)
                        return customerReportConfirm(formData)
                    })
                    .then(res => {
                        this.$Message.success(this.$t('tips.update.success'))
                    })
                    .catch(err => {
                        options.closeModal = false
                    })
                    .finally(() => {
                        next()
                    })
            })
        }
    }
</script>
<style lang="less"
       scoped>
</style>
